export default "__VITE_ASSET__DH$e1izq__"